exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-footer--sticky[data-v-883190f0] {\n  position: sticky;\n  bottom: 0;\n  background-color: inherit; /* [1] */\n  z-index: 1055; /* [2] */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-883190f0","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/booking/components/ServiceItemModal.vue
// module id = 1819
// module chunks = 0